module.exports = __webpack_public_path__ + "static/media/dark-logo.cf7390a2.svg";